var HeaderData = require("./headerData.js");
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var PathData = require('../../../svg/pathData.js');
var EllipseData = require('../../../svg/ellipseData.js');
var RectangleData = require('../../../svg/rectangleData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var PthComponentAttribute = require('./pthComponentAttribute.js');

var HeaderStraightData = function(position, angle, init) {
    HeaderData.apply(this, arguments);

    this.terminalTailLength = this.value("terminalTailLength", true);
    this.nonTransformedSegmentedGeometry.addTrigger(this.terminalTailLength);
};

lib_core.inherit(HeaderStraightData, HeaderData);
lib_core.JsonParser.registerClass(HeaderStraightData, "HeaderStraightData");
module.exports = HeaderStraightData;

HeaderStraightData.prototype.setupMinMaxPtrMap = function() {
    HeaderData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["terminalTailLength"] = [this.terminalTailLength];
};

HeaderStraightData.prototype.getAssemblyOutline = function(pads) {
    if (pads.length === 0) return;

    var body = this.getBodyForAssembly();
    var footprintPadsBBox = this.getFootprintPadsBBox(pads);

    var outline = new RectangleData(new lib_geometry.Coord(0, 0), 0, body.height, body.width, false, IPCRules.assemblyOutlineStrokeWidth);
    outline.move(new lib_geometry.Coord(footprintPadsBBox.x + footprintPadsBBox.width / 2, footprintPadsBBox.y + footprintPadsBBox.height / 2));

    return outline;
};

HeaderStraightData.prototype.getSilkscreen = function(pads) {
    if(pads.length === 0) return [];

    var silkscreen = [];
    var footprintPadsBBox = this.getFootprintPadsBBox(pads);
    var footprintPadsCentroidLocation = new lib_geometry.Coord(footprintPadsBBox.x + footprintPadsBBox.width / 2, footprintPadsBBox.y + footprintPadsBBox.height / 2);
    var body = this.getBodyForSilkscreen();
    
    //resize body silkscreen size with minimum silkscreen clearence from pads
    //note: body object has reverse meaning of width and height than in pads bbox
    body.width = Math.max(body.width, footprintPadsBBox.height + 2 * IPCRules.silkscreenClearance);
    body.height = Math.max(body.height, footprintPadsBBox.width + 2 * IPCRules.silkscreenClearance);
    
    ////////////////////
    //   Pin Marker   //
    ////////////////////
    //TODO: use getPinOneMarker() from parent class
    
    //dot location depends on footprint origin which is the location of first pad
    var firstPad = pads[0];
    var pinMarkerPosX, pinMarkerPosY;
    var totalDotMarkerClearence = IPCRules.silkscreenPinMarkerDotClearance + IPCRules.dotPinMarkerSize / 2;
    var pinOneOriginPositionId = PthComponentAttribute.type.HEADER.pinNumberSequencePattern[this.pinNumberSequencePattern()].pinOnePositionId;

    //draw dot marker beside pad 1 maintaining clearance from pad if pad is outside the body
    //draw dot marker beside pad 1 maintaining clearance from body if pad is inside the body
    switch(pinOneOriginPositionId) {
        case this.pinOneOriginLocation.TOP_LEFT:
        case this.pinOneOriginLocation.TOP_RIGHT:
            pinMarkerPosX = firstPad.pos().x;

            if(body.width / 2 > Math.abs(firstPad.pos().y + firstPad.getTopCopper().width() / 2 - footprintPadsCentroidLocation.y)) {
                pinMarkerPosY = footprintPadsCentroidLocation.y + body.width / 2 + totalDotMarkerClearence;
            } else {
                pinMarkerPosY = firstPad.pos().y + firstPad.getTopCopper().width() / 2 + totalDotMarkerClearence;
            }
        break;

        case this.pinOneOriginLocation.BOTTOM_LEFT:
        case this.pinOneOriginLocation.BOTTOM_RIGHT:
            pinMarkerPosX = firstPad.pos().x;

            if(body.width / 2 > Math.abs(firstPad.pos().y - firstPad.getTopCopper().width() / 2 - footprintPadsCentroidLocation.y)) {
                pinMarkerPosY = footprintPadsCentroidLocation.y - body.width / 2 - totalDotMarkerClearence;
            } else {
                pinMarkerPosY = firstPad.pos().y - firstPad.getTopCopper().width() / 2 - totalDotMarkerClearence;
            }
        break;
    }
    
    silkscreen.push(new EllipseData(new lib_geometry.Coord(pinMarkerPosX, pinMarkerPosY), 0, IPCRules.dotPinMarkerSize, IPCRules.dotPinMarkerSize, true, 0));

    //////////////////////////////
    //   Component Silkscreen   //
    //////////////////////////////
    
    /*
        Draw silkscreen around body.
        Since footprint origin is the location of first pad, body center must be matched with footprint pads bbox center.
        So body must be translated to pads bbox center.
     */
    var componentBodyOutline = new RectangleData(new lib_geometry.Coord(0, 0), 0, body.height, body.width, false, IPCRules.silkscreenStrokeWidth);
    componentBodyOutline.move(footprintPadsCentroidLocation);
    silkscreen.push(componentBodyOutline);

    return silkscreen;
};